import { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { initNativeApp, registerPushForUser } from "@/lib/native";

// Runs native-only setup inside the Android app; no-op on the web.
export function NativeBootstrap() {
  const { user } = useAuth();
  useEffect(() => { initNativeApp(); }, []);
  useEffect(() => { if (user) registerPushForUser(); }, [user?.id]); // eslint-disable-line
  return null;
}
